import React, { useState } from 'react';
import Typography from '../../components/Typography/Typography';
import styles from './style.module.css'
import { CartContent } from '../../components/CartContent';
import { shoe } from '../../assets/images';
import FlatButtons from '../../components/FlatButton/FlatButton';
import { InputField } from '../../components/InputField';
import { useNavigate } from 'react-router-dom';

const BuyerCartPage: React.FC = () => {

  const navigate = useNavigate()

  const goToCheckOut = () => {
    navigate("/buyer-checkout")
  }

  const [discountCode, setDiscountCode] = useState("")

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setDiscountCode(e.target.value)
  }

  const cartItem = [
    {
      id: 1,
      name: "Wireless Bluetooth Headphones",
      category: "Electronics",
      stockNumber: 7,
      colour: "Black",
      price: 89.99,
      image: "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=200&h=200&fit=crop&crop=center",
      quantity: 1,
    },
    {
      id: 2,
      name: "Smart Watch",
      category: "Electronics",
      stockNumber: 8,
      colour: "Silver",
      price: 120.0,
      image: "https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?w=200&h=200&fit=crop&crop=center",
      quantity: 2,
    },
    {
      id: 3,
      name: "Ankle Hight Boots",
      category: "Shoe",
      stockNumber: 7,
      colour: "Black",
      price: 999.29,
      image: `${shoe}`,
      quantity: 1,
    },
    {
      id: 4,
      name: "Running Shoes",
      category: "Footwear",
      stockNumber: 4,
      colour: "Blue",
      price: 75.50,
      image: "https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=200&h=200&fit=crop&crop=center",
      quantity: 1,
    },
    {
      id: 4,
      name: "Running Shoes",
      category: "Footwear",
      stockNumber: 4,
      colour: "Blue",
      price: 75.50,
      image: "https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=200&h=200&fit=crop&crop=center",
      quantity: 1,
    },
    {
      id: 4,
      name: "Running Shoes",
      category: "Footwear",
      stockNumber: 4,
      colour: "Blue",
      price: 75.50,
      image: "https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=200&h=200&fit=crop&crop=center",
      quantity: 1,
    },{
      id: 4,
      name: "Running Shoes",
      category: "Footwear",
      stockNumber: 4,
      colour: "Blue",
      price: 75.50,
      image: "https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=200&h=200&fit=crop&crop=center",
      quantity: 1,
    },{
      id: 4,
      name: "Running Shoes",
      category: "Footwear",
      stockNumber: 4,
      colour: "Blue",
      price: 75.50,
      image: "https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=200&h=200&fit=crop&crop=center",
      quantity: 1,
    },
    {
      id: 4,
      name: "Running Shoes",
      category: "Footwear",
      stockNumber: 4,
      colour: "Blue",
      price: 75.50,
      image: "https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=200&h=200&fit=crop&crop=center",
      quantity: 1,
    },{
      id: 4,
      name: "Running Shoes",
      category: "Footwear",
      stockNumber: 4,
      colour: "Blue",
      price: 75.50,
      image: "https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=200&h=200&fit=crop&crop=center",
      quantity: 1,
    },
  ]

  return (
    <div className={styles.container}>

      <div className={styles.cartContainer}>

        <div className={styles.cart}>

          <Typography className={styles.cartText}>
            My Cart
          </Typography>

        </div>

        <div className={styles.cartItemContainer}>

          {
            cartItem.map((item) => (
              <CartContent
                key={item.id}
                id={item.id}
                name={item.name}
                category={item.category}
                stockNumber={item.stockNumber}
                colour={item.colour}
                price={item.price}
                image={item.image}
                initialQuantity={item.quantity}
              />
            ))}
        </div>

        <div className={styles.updateContainer}>

          <FlatButtons
            onClick={() => {
              // window.location.href = '/choose-template';
            }}
            className={styles.primaryButton}
          >
            <Typography
              variant="buttonText"
              fontFamily="satoshi"
              weight="regular"
              size="base"
              className={styles.primaryButtonText}
            >
              Update Cart
            </Typography>
          </FlatButtons>

        </div>

      </div>

      <div className={styles.summaryContainer}>

        <div className={styles.summary}>

          <Typography className={styles.summaryText}>
            Order Summary
          </Typography>

        </div>

        <div className={styles.summaryContent}>

          <div className={styles.discountField}>

            <div className={styles.inputContainer}>
              <InputField
                title='Discount Code'
                value={discountCode}
                onChange={handleChange}
              />
            </div>

            <div className={styles.applyBtnContainer}>

              <FlatButtons
                // onClick={() => { goToCheckOut() }}
                className={styles.applyButton}
              >
                <Typography
                  variant="buttonText"
                  fontFamily="satoshi"
                  weight="regular"
                  size="base"
                  className={styles.applyButtonText}
                >
                  Apply
                </Typography>
              </FlatButtons>

            </div>

          </div>
          
          <div className={styles.detailedSummary}>

            <div className={styles.detailedSummaryItem}>

              <Typography
                variant='heading6'
                className={styles.sub}
              >
                Subtotal
              </Typography>

              <Typography className={styles.subAmount}>
                $8598549
              </Typography>

            </div>

            <div className={styles.detailedSummaryItem}>

              <Typography
                variant='heading6'
                className={styles.sub}
              >
                Discount
              </Typography>

              <Typography className={styles.discountAmount}>
                $3098547
              </Typography>

            </div>

            <div className={styles.detailedSummaryItem}>

              <Typography
                variant='heading6'
                className={styles.sub}
              >
                Total
              </Typography>

              <Typography className={styles.subAmount}>
                $748739
              </Typography>

            </div>

          </div>

          <div className={styles.proceedBtnContainer}>

            <FlatButtons
              onClick={() => { goToCheckOut() }}
              className={styles.applyButton}
            >
              <Typography
                variant="buttonText"
                fontFamily="satoshi"
                weight="regular"
                size="base"
                className={styles.applyButtonText}
              >
                Proceed to Checkout
              </Typography>
            </FlatButtons>

          </div>


        </div>

      </div>

    </div >
  );
};

export default BuyerCartPage;
